import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import About from '../components/About'
import Contact from '../components/Contact'
import Intro from '../components/Intro'
import Protocol from '../components/Protocol'
import Login from '../components/Login'
import Privacy from '../components/Privacy'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/intro',
            name: 'Intro',
            component: Intro
        },
        {
            path: '/protocol',
            name: 'Protocol',
            component: Protocol
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
                {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        },
    ]
})
